import { makeAutoObservable } from 'mobx'

import { PrivacyPolicyApi } from 'shared/api/PrivacyPolicyApi.ts'
import { PrivacyPolicyModel } from 'shared/api/PrivacyPolicyModel'

export type PrivacyPolicyLoadStatus = 'idle' | 'loading' | 'success' | 'error'

export class PrivacyPolicyStore {
  policyFiles: PrivacyPolicyModel | null = null
  status: PrivacyPolicyLoadStatus = 'idle'
  private request: Promise<PrivacyPolicyModel | undefined> | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  ensurePrivacyPolicy(): Promise<PrivacyPolicyModel | undefined> {
    if (this.policyFiles !== null) {
      this.status = 'success'
      return Promise.resolve(this.policyFiles)
    }

    if (this.request) return this.request

    this.status = 'loading'
    this.request = this.loadPrivacyPolicy().finally(() => {
      this.request = null
    })

    return this.request
  }

  private async loadPrivacyPolicy(): Promise<PrivacyPolicyModel | undefined> {
    try {
      const { data: response } = await PrivacyPolicyApi.getPolicy()

      const data = response.data
      this.policyFiles = data
      this.status = 'success'

      return data
    } catch {
      this.status = 'error'
      return undefined
    }
  }
}

export default new PrivacyPolicyStore()
